module.exports = __webpack_public_path__ + "img/treat-3.ed815eac.svg";